import React, { useEffect, useState } from "react";
import { Input } from "semantic-ui-react";
import classNames from "classnames";
import { connectField } from "uniforms";

import { CurrencyDropdown } from "./CurrencySelect";
import { DEFAULT_CURRENCY } from "/imports/api/_jsonSchemas/enums/costs";
import { IFieldCoreProps } from "./_interfaces";

import Debug from "debug";
const debug = Debug("pricerequest:quickbid:curencyamountinput");

interface ICurrencyAmountInputProps extends IFieldCoreProps<{ value: number, unit: string }> {
  options?: {
    disableCurrency?: boolean;
    additionalOptions?: string[],
    currencyFieldName?: string;
  },
  accountId?: string;
}

/** currency amount input
 * @returns {value: Number, unit: String}
 */
const CurrencyAmountInput = ({
  disabled,
  id,
  inputRef,
  label,
  onChange,
  placeholder,
  required,
  error,
  accountId,
  value,
  options // {disableCurrency, additionalOptions, currencyField}
}: ICurrencyAmountInputProps) => {
  const currencyFieldName = options?.currencyFieldName || "unit";
  const [stateValue, setStateValue] = useState({ value: 0, [currencyFieldName]: DEFAULT_CURRENCY });
  useEffect(() => {
    if (typeof value === "object" && value && Object.keys(value).length) {
      const untiedValue = {
        value: value?.value || 0,
        [currencyFieldName]: value?.[currencyFieldName] || DEFAULT_CURRENCY,
      };
      setStateValue(untiedValue);
    }
  }, [value]);
  const { value: amount } = stateValue;
  const handleAmount = (e, { value: newAmount }) => {
    const newState = { ...stateValue, value: parseFloat(newAmount) || "" };
    onChange(newState);
  };
  const handleCurrency = newUnit => {
    const newState = { ...stateValue, [currencyFieldName]: newUnit };
    onChange(newState);
  };

  // debug("repaint currencyAmount", options);
  const currencyDropdown = () => (
    <CurrencyDropdown
      asLabel={true}
      value={stateValue[currencyFieldName]}
      disabled={options?.disableCurrency}
      additionalOptions={options?.additionalOptions}
      onChange={handleCurrency}
      accountId={accountId}
    />
  );
  return (
    <div className={classNames("field", { required, error })}>
      <label htmlFor={id}>{label}</label>

      <Input
        id={id}
        disabled={disabled}
        ref={inputRef}
        value={amount}
        type="number"
        label={currencyDropdown}
        labelPosition="right"
        placeholder={placeholder}
        onChange={handleAmount}
      />
    </div>
  );
};

export default connectField<any>(CurrencyAmountInput);
